import { SKU_CATEGORY } from '../PaymentProvider.d';

const isContainShipmentProduct = (product, index) => {
  const SKUCategory = product?.SKUCategory;
  return SKUCategory === SKU_CATEGORY.BOOK;
};

export default isContainShipmentProduct;
